import classNames from 'classnames'
import React from 'react'

export interface TagProps {
    text: string
    className?: string
}

export const Tag = (props: TagProps): JSX.Element => {
    const { text } = props

    const className: string = classNames('tag', props.className)

    return (
        <div className={className}>
            <span className="tag__text">{text}</span>
        </div>
    )
}
